<div class="mb-2" style="background-color: cadetblue; height: 60px;">
    <div style="width: 100%; display: flex; justify-content: flex-end; position: relative;">
        <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt="" style="cursor: pointer; padding: 8px 8px 0 0;"> 
     </div>
     <span class="fs-16px mt-2 text-white" style="padding: 8px 12px;"><b>Descarga de Pendientes de Alta en Bancos</b></span>
</div>
<div style="background-color: white; width: 100%; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">
    <form class="w-100" [formGroup]="estatusForm">
        <div class="col-sm-12 form-group form-inline margin-responsive mb-4">
            <span style="color: black; font-weight: bold; font-size: 16px;">Fecha Inicio</span>
            <div class="dp-hidden position-absolute">
              <div class="input-group">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker" style="width: 0;"
                  [autoClose]="'outside'" (dateSelect)="onDateSelection($event)" [displayMonths]="displayMonths"
                  [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1" />
                <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                  </span>
                </ng-template>
              </div>
            </div>
            <div class="input-group">
              <input #dpFromDate class="form-control" placeholder="dd-mm-yyyy" name="dpFromDate" disabled
                [value]="formatter.format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value)" />
              <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button">
                <i class="fas fa-calendar-days fa-fw"></i>
              </button>
            </div>
        </div>
    
        <div class="col-sm-12 form-group form-inline margin-responsive mb-4">
            <span style="color: black; font-weight: bold; font-size: 16px;">Fecha Final</span>
            <div class="input-group">
              <input #dpToDate class="form-control" placeholder="dd-mm-yyyy" name="dpToDate" disabled
                [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)" />
              <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button">
                <i class="fas fa-calendar-days fa-fw"></i>
              </button>
            </div>
        </div>
        <div class="d-flex flex-column w-100 mb-3">
            <span style="color: black; font-weight: bold;">Tipo de Cuenta</span>
            <select formControlName="tipoCuenta" class="form-control form-select ml-2">
              <option value="">Todos</option>
              <option *ngFor="let item of cuentas" [value]="item.descripcion">{{item.descripcion}}</option>
            </select>
        </div>   
    </form>
    <div class="d-flex justify-content-around align-items-center w-100">
        <button class="btn btn-secondary mt-4" (click)="closeDialog()">Cerrar</button>
        <!-- <button class="btn btn-primary mt-4" (click)="guardarCambios()">Descargar</button>-->
        <button class="btn btn-primary mt-5" [disabled]="validarDescarga()" (click)="guardarCambios()">Descargar</button>
    </div>
</div>